<template>
  <div class="header_box">
    <div class="title_box">
      <img v-if="LogoPath" :src="LogoPath" alt="logo" style="height: 0.7rem;width: 0.7rem;margin-right: 0.3rem;">
      <p>{{ title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderComponent', // Vue2推荐显式声明组件名
  // 替换Vue3的defineProps，使用Vue2的props选项
  props: {
    title: {
      type: String,
      default: ''
    },
    LogoPath: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* 1. 移除lang="scss"；2. 展开SCSS嵌套为普通CSS；3. 替换--el开头的CSS变量 */
.header_box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-primary-dark-2); /* 原--el-color-primary-dark-2 → --color-primary-dark-2 */
  border-radius: 0.1rem;
}

.header_box .title_box {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>